export class DependentScoreKpiModel {
    public id :any;
    public row_id :any;
	public kpi_id :any ;
    public complex_kpi_id :any ;
    public comm_plan_dtl_id: any;
	public kpi_name :string ;
	public kpi_weight : any ;
	public created_dt :Date ;
	public created_by :string;
	public update_dt :Date;
	public updated_by :string;
    public comp_plan_id: any;
    public is_score_vars: string;
    public depndentKpis : any ;

    public ch_kpiid : any ;
    public chargeback_depndt_kpi_id : any ;
    public chargeback_effective_date : any ;
   
     constructor(){
        this.ch_kpiid = null;
        this.chargeback_depndt_kpi_id = null;
        this.chargeback_effective_date = null;

        this.depndentKpis = null;
        this.is_score_vars = null;
        this.id = null;
        this.row_id = null;
        this.kpi_id = null;
        this.complex_kpi_id = null;
        this.kpi_name = null;
        this.kpi_weight = null;
        this.created_by = null;
        this.created_dt = null;
        this.updated_by = null;
        this.update_dt = null;
        this.comp_plan_id = null;
        this.comm_plan_dtl_id = null;
     }
}
